import { LadleStatusPage } from "./LadleStatusPage";

type Props = {};
const LadleStatus = (props: Props) => {
	return <LadleStatusPage />;
};
export default LadleStatus;
